import * as _ from 'underscore';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import MegaDrop from '../MegaDrop/MegaDrop';
import * as DesignerState from '../../../../state/reducer/designer/designer';

import * as Utils from '../../../../lib/designerUtils';
import Console from '../../../../lib/debug';

class ExerciseSelect extends PureComponent {
    create = () => {
        let block = this.props.block;
        let exercise = this.props.exercise;
        DesignerState.toggleExerciseDialog(block, exercise, true, true);
    };
    exerciseUpdate = newValue => {
        let block = this.props.block;
        let exercise = this.props.exercise;
        let exerciseTags = this.props.exerciseTags;
        let match = _.findWhere(this.props.exerciseRef.options, {
            id: newValue.id
        });

        if (newValue.className) {
            return this.create({ label: '' });
        }

        if (match && !exerciseTags.length) {
            exerciseTags = this.getExerciseTags(match.tags);
        }

        let setExercise = {
            ...this.props.exercise,
            exercise_id: newValue.id,
            no_sets: newValue.no_sets,
            title: newValue.title,
            tags: newValue.tags,
            video_url: newValue.video_url,
            video_thumbnail: null
        };

        if (!setExercise.param_count) {
            setExercise.param_1_type = newValue.param_1_type;
            setExercise.param_2_type = newValue.param_2_type;
        }

        DesignerState.swapExercise(block, exercise, newValue);
    };
    filterByTags = _tags => {
        let allOptions = this.props.exerciseRef.options
            ? this.props.exerciseRef.options
            : this.props.exerciseRef;
        return Utils.filterOptionsByTags(allOptions, _tags);
    };
    filterUpdate = newValue => {
        let dispatch = this.props.dispatch;
        let exercise = this.props.exercise;
        DesignerState.updateTags(dispatch, exercise, newValue);
    };
    getExerciseTags = tags => {
        let newTags = tags.length ? tags.slice(0) : [];
        if (newTags.length > 3) {
            newTags.splice(3, newTags.length - 3);
        }
        return newTags;
    };
    getOptions() {
        let exercise = this.props.exercise;
        let tags = exercise ? exercise.tags : [];
        return this.filterByTags(tags);
    }
    render() {
        Console.render('designer.ExerciseSelect');
        let exercise = this.props.exercise;
        let tagRef = this.props.tagRef;
        let options = this.getOptions();
        let exerciseSelectClasses = 'exercise-select';

        return (
            <div
                className={exerciseSelectClasses}
                ref={el => (this.exerciseDOMElement = el)}
            >
                <div className="exe-box">
                    <MegaDrop
                        value={exercise}
                        type="exercise"
                        placeholder="Select Exercise"
                        options={options}
                        optionsRef={this.props.exerciseRef}
                        tags={this.props.exerciseTags}
                        selectedTags={exercise ? exercise.tags : []}
                        itemSelect={this.exerciseUpdate}
                        handleTags={this.filterUpdate}
                        createItem={this.create}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToExerciseSelectProps = (state, ownProps) => {
    let exerciseRef = state.library.exerciseBenchmarkRef;

    if (ownProps.onlyExerciseElements) {
        exerciseRef = state.library.exerciseRef;
    }

    return {
        exercise: state.calendar.exerciseTree[ownProps.exerciseKey],
        exerciseRef: exerciseRef,
        exerciseTags: state.calendar.uiTree.exerciseTags,
        ...ownProps
    };
};

export default connect(mapStateToExerciseSelectProps)(ExerciseSelect);
